export const ICON = {
  qq: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/img-qq.png',
  qqZone: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/img-qqkj.png',
  qqChannel: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/img-qq-channel.png',
  weixin: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/img-wx.png',
  weixinZone: 'https://image-1251917893.file.myqcloud.com/Esports/new/admin/img-pyq.png',
  weibo: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/wb.png',
  yuba: 'https://image-1251917893.file.myqcloud.com/Esports/new/user/yuba.png',
};

export const ShareType = {
  douyuPanel: 0,
  weixin: 1,
  weixinZone: 2,
  qq: 3,
  qqZone: 4,
  qqChannel: 5,
  weibo: 6,
  yuba: 7, // 鱼吧
};

export const SHARE_OPTIONS = {
  qq: {
    icon: ICON.qq,
    name: 'QQ好友',
    type: ShareType.qq,
  },
  qqZone: {
    icon: ICON.qqZone,
    name: 'QQ空间',
    type: ShareType.qqZone,
  },
  qqChannel: {
    icon: ICON.qqChannel,
    name: 'QQ频道',
    type: ShareType.qqChannel,
  },
  weixin: {
    icon: ICON.weixin,
    name: '微信好友',
    type: ShareType.weixin,
  },
  weixinZone: {
    icon: ICON.weixinZone,
    name: '朋友圈',
    type: ShareType.weixinZone,
  },
  weibo: {
    icon: ICON.weibo,
    name: '微博',
    type: ShareType.weibo,
  },
  yuba: {
    icon: ICON.yuba,
    name: '鱼吧',
    type: ShareType.yuba,
  },
};
